import React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { hasTrussDesignPermission } from '@paragon/login-tools';
import { WalkthroughBlurbAnchor } from '@paragon/tour-guide';

import { useAppMonitor } from '../../../monitor';
import { duplicateActiveComponentDesign } from '../../../store/actions/appActions';
import { getActiveComponentDesign } from '../../../store/selectors/getActiveComponentDesignSelector';
import { getActiveJobLayoutModel, isParagonRepairJobOpen } from '../../../store/selectors/jobContextSelectors';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function DuplicateComponentButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const layoutViewActive = useAppSelector(isLayoutViewActive);
  const hasPermission = useAppSelector(hasTrussDesignPermission);
  const nonRepairJobOpen = useAppSelector(
    (state) => getActiveJobLayoutModel(state) != null && !isParagonRepairJobOpen(state),
  );

  const activeComponentDesign = useAppSelector(getActiveComponentDesign);

  if (layoutViewActive || !hasPermission || nonRepairJobOpen) return null;

  return (
    <WalkthroughBlurbAnchor id="duplicate-component-button" blurbPlacement="bottom">
      <ToolbarIconButton
        title="Duplicate Truss"
        icon={<ContentCopyIcon />}
        onClick={() => {
          dispatch(duplicateActiveComponentDesign());
          monitor.recordInteraction('Duplicate Component button clicked');
        }}
        disabled={activeComponentDesign == null}
      />
    </WalkthroughBlurbAnchor>
  );
}
